module.exports = __webpack_public_path__ + "img/icon-3.9303a54c.png";